import autocomplete from 'jquery-ui/ui/widgets/autocomplete';

$(function () {
  // Autocompletes
  $(".js-minerva-form-autocomplete").each(function () {
    var source = $.parseJSON($(this).find('script[type="application/json"]').text());
    $(this).find('input').autocomplete({
      source: source, // TODO: Use remote API with filter
    });
  });
});



// WEBPACK FOOTER //
// lib/js/minerva-form/autocomplete.js